<template>
  <div
    v-if="show && !isAuditMode"
    id="annotationToolRibbon"
    class="ribbon"
  >
    <div class="ribbon__group">
      <IconButton
        id="undoBtn"
        v-tooltip="'Undo'"
        class="ribbon__button"
        aria-label="Undo"
        :disabled="!canUndo"
        :icon="'undo'"
        :showHover="false"
        :type="''"
        @click="handleUndo"
      />
      <IconButton
        id="revertChangesBtn"
        v-tooltip="'Revert All Changes'"
        class="ribbon__button"
        aria-label="Revert All Changes"
        :icon="'restore'"
        :showHover="false"
        :type="''"
        @click="handleRevertChanges"
      />
      <IconButton
        id="copyBtn"
        v-tooltip="'Copy Annotations (ctrl + c)'"
        class="ribbon__button"
        aria-label="Copy Annotation"
        :icon="'copy'"
        :showHover="false"
        :type="''"
        @click="handleCopyAnnotation"
      />
      <IconButton
        id="pasteBtn"
        v-tooltip="'Paste Annotations (ctrl + v)'"
        class="ribbon__button"
        aria-label="Paste Annotation"
        :icon="'paste'"
        :showHover="false"
        :type="''"
        :disabled="!hasCopiedAnnotations"
        @click="handlePasteAnnotation"
      />
      <!-- <IconButton
        id="delBtn"
        v-tooltip="'Delete Annotations (ctrl + x)'"
        class="ribbon__button"
        aria-label="Delete Annotations"
        :icon="'remove_selection'"
        :showHover="false"
        :type="''"
        @click="handleDeleteAnnotationsBulk"
      /> -->
    </div>

    Click Info to get more information
    <HelpTip help_style="info">
      <div v-if="editMode=='pointer'">Click on any item to edit. 
      </div>
      <div v-if="editMode=='line'">Click on the image to start drawing polygon.  Click in pointer mode to finish. Then click 'SAVE IMAGE ANNOTAtion' item when done. 
      </div>
      <div v-if="PerformKeyFrameInterpolation">
        <p>While in key frame Editing Mode:</p>  
        <p>Select an annotation (bounding box) to include it in the key frame sequence</p>  
        <p>De-select an annotation to exclude it in the key frame sequence</p>  
        <p>Go to any frame and select items or draw object to include in the key frame sequence</p>  
        <p>Only one object key frame sequence is allowed at one time. Multiple key frames are allowed</p>  
        <p>When key frames are completed, Click on 'GENERATE KEYFRAMES'. His will create dotted (unsaved) annotatons </p>
        <p>Preview the anew annotation in the frames by moving to different frames</p>    
        <p>If preview is good, click on 'SAVE NEW ANNOTATIONS' </p>  
      </div>
      <div v-if="editMode=='agtg'">
        <p>Starts a new background process to automate teh annotation process.</p>  
      </div>
    </HelpTip>

    <div class="ribbon__group">
      <!-- <IconButton
        v-if="hasSelection"
        id="showAnnotationInfoBtn"
        class="ribbon__button"
        aria-label="Show Annotation Info"
        :icon="'auto'"
        :showHover="false"
        :type="''"
        :title="'Show Annotation Info'"
        @click="handleShowAnnotationInfo"
      /> -->


   
      <template v-if="doKeyframesExist">
        <button
          v-tooltip="'Generate Key Frames'"
          class="button ribbon__button-primary"
          :class="{'button-spinner': isSubmittingKeyframes}"
          :disabled="isSubmittingKeyframes"
          @click="handleSubmitKeyframes"
        >
          Generate Keyframes
        </button>
      </template>

      <template v-if="doKeyframesExist">
        <button
          v-tooltip="'Remove Keyframe'"
          class="button ribbon__button-primary"
          :class="{'button-spinner': isSubmittingKeyframes}"
          :disabled="isSubmittingKeyframes"
          @click="handleClearKeyframes"
        >
          Clear Keyframes
        </button>
      </template>

      <template v-if="newAnnotationsSavePending">
        <button
          v-tooltip="'Save Annotation in all images'"
          class="button ribbon__button-primary"
          :class="{'button-spinner': isSubmittingKeyframes}"
          :disabled="isSubmittingKeyframes"
          @click="handleSaveNewAnnotations"
        >
          Save New Annotations
        </button>
      </template>
      <hr class="ribbon__vr">
      <!-- <button
        class="button button-secondary ribbon__button-secondary"
        :title="'Skip Image (Right Arrow)'"
        @click="handleSkipSequence"
      >
        Skip Sequence
      </button> -->

      <button
        v-tooltip="'Submit Annotations for Current Image (Enter)'"
        class="button button-rounded ribbon__button-primary"
        :class="{'button-spinner': isSubmitting}"
        :disabled="isSubmitting"
        @click="handleLabellingSubmit"
      >
        Save Image Annotations
      </button>
      <!-- <button
        v-if="hasReviewTask"
        class="button ribbon__button-primary"
        :title="'Finish Editing Sequence'"
        @click="completeTaskSequence"
      >
        Finish Editing Sequence
      </button> -->
    </div>
  </div>
  <div v-if="show && isAuditMode" id="annotationToolRibbon" class="ribbon">
    <div class="ribbon__group">
      <IconButton
        id="undoBtn"
        v-tooltip="'Undo'"
        class="ribbon__button"
        aria-label="Undo"
        :disabled="!canUndo"
        :icon="'undo'"
        :showHover="false"
        :type="''"
        @click="handleUndo"
      />
      <IconButton
        id="revertChangesBtn"
        v-tooltip="'Revert All Changes'"
        class="ribbon__button"
        aria-label="Revert All Changes"
        :icon="'restore'"
        :showHover="false"
        :type="''"
        @click="handleRevertChanges"
      />
      <IconButton
        id="copyBtn"
        v-tooltip="'Copy Annotations (ctrl + c)'"
        class="ribbon__button"
        aria-label="Copy Annotation"
        :icon="'copy'"
        :showHover="false"
        :type="''"
        @click="handleCopyAnnotation"
      />
      <IconButton
        id="pasteBtn"
        v-tooltip="'Paste Annotations (ctrl + v)'"
        class="ribbon__button"
        aria-label="Paste Annotation"
        :icon="'paste'"
        :showHover="false"
        :type="''"
        :disabled="!hasCopiedAnnotations"
        @click="handlePasteAnnotation"
      />
      <!-- <IconButton
        id="delBtn"
        class="ribbon__button"
        aria-label="Delete Annotations"
        :icon="'remove_selection'"
        :showHover="false"
        :type="''"
        :title="'Delete Annotations (ctrl + x)'"
        @click="handleDeleteAnnotationsBulk"
      /> -->
    </div>

    <div class="ribbon__group">
      <IconButton
        v-if="hasSelection"
        id="showAnnotationInfoBtn"
        v-tooltip="'Show Annotation Info'"
        class="ribbon__button"
        aria-label="Show Annotation Info"
        :icon="'auto'"
        :showHover="false"
        :type="''"
        @click="handleShowAnnotationInfo"
      />
      <!-- <button
        class="button button-danger ribbon__button-secondary button-flex"
        :title="'Delete Image'"
        @click="handleDeleteImageFromDataset"
      >
        <SVGIcon
          class="me-1"
          :iconName="'delete'"
          :width="'20px'"
          :height="'20px'"
        />
        Delete Image
      </button> -->
      <IconButton
        v-if="hasSelection && trackingIdSelected"
        id="deleteTrackingIdBtn"
        class="ribbon__button"
        aria-label="Delete All Annotation in Series"
        :icon="'delete_sweep'"
        :showHover="false"
        :type="''"
        :title="'Delete All Annotation in Series'"
        @click="handleDeleteTrackingIdClicked(trackingIdSelected)"
      />
      <template v-if="hasSelection">
        <button
          v-if="!isKeyframeSelected"
          class="button button-secondary ribbon__button-secondary"
          :title="'Set Keyframe'"
          @click="handleSetKeyframe"
        >
          Set Keyframe
        </button>
        <button
          v-else
          class="button button-secondary ribbon__button-secondary"
          :title="'Remove Keyframe'"
          @click="handleRemoveKeyframe"
        >
          Remove Keyframe
        </button>
      </template>
      <template v-if="doKeyframesExist">
        <button
          class="button ribbon__button-primary"
          :class="{'button-spinner': isSubmittingKeyframes}"
          :disabled="isSubmittingKeyframes"
          :title="'Remove Keyframe'"
          @click="handleSubmitKeyframes"
        >
          Submit Keyframes
        </button>
        <hr class="ribbon__vr">
      </template>
      <!-- <button
        class="button button-secondary ribbon__button-secondary"
        :title="'Skip Image (Right Arrow)'"
        @click="handleSkipSequence"
      >
        Skip Sequence
      </button> -->
      <BasePersistentSplitButton
        v-model="submitType"
        class="ribbon__button-primary"
        title="Submit Annotations for Current Image (Enter)"
        :options="submitTypes"
        @click="handleReviewSubmit"
      />
      <!-- <button
        v-if="hasReviewTask"
        class="button ribbon__button-primary"
        :title="'Finish Editing Sequence'"
        @click="completeTaskSequence"
      >
        Finish Editing Sequence
      </button> -->
    </div>
  </div>
  <ConfirmModal
    ref="confirmModal"
    :messageHeader="confirmMessageHeader"
    :message="confirmMessage"
    :buttonClass="'button-delete'"
    :buttonText="buttonText"
    @confirmed="confirmFunction"
  />
</template>

<script setup>
import HelpTip from '@/components/HelpTip.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import IconButton from '@/components/IconButton.vue';
import BasePersistentSplitButton from '@/components/BasePersistentSplitButton.vue';
import useTasks from '@/composables/annotationTool/useTasks.js';
import useViewerVisualizations from '@/composables/useViewerVisualizations.js';
import { useViewerVisualizationsStore } from '@/stores/useViewerVisualizationsStore.js';
import {
  ref, toRefs, onMounted, computed, watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ConfirmModal from '@/components/ConfirmModal.vue';
import { useEditorStore } from '@/stores/useEditorStore.js';

const props = defineProps({
  show: {
    type: Boolean,
    default: true,
  },
  canUndo: {
    type: Boolean,
    default: false,
  },
  hasSelection: {
    type: Boolean,
    default: false,
  },
  annotationDisplaySettings: {
    type: Object,
    default: null,
  },
  isAuditMode: {
    type: Boolean,
    default: false,
  },
  frameImageObj: {
    type: Object,
    default: null,
  },
  reviewSettings: {
    type: Object,
    default: null,
  },
  selectedAnnotations: {
    type: Array,
    default: () => [],
  },
  hasCopiedAnnotations: {
    type: Boolean,
    default: false,
  },
  editMode: {
    type: String,
    default: "",
  },
});
const {
  show,
  canUndo,
  hasSelection,
  annotationDisplaySettings,
  isAuditMode,
  frameImageObj,
  reviewSettings,
  selectedAnnotations,
} = toRefs(props);

const emit = defineEmits([
  'undo',
  'revert-changes',
  'show-annotation-info',
  'skip',
  'submit',
  'copy',
  'paste',
  'bulk-del-ann',
]);

const confirmModal = ref(null);
const confirmMessage = ref(null);
const confirmMessageHeader = ref(null);
const confirmFunction = ref(null);
const buttonText = ref(null);
const isSubmitting = ref(false);

const editorStore = useEditorStore();
const { currentSample,newAnnotationsSavePending, changedAnnotations} = storeToRefs(editorStore);
const { PerformKeyFrameInterpolation, clearChangedAnnotationsForImage } = editorStore;

const {
  sequenceId,
  submitType,
  skipTaskSequence,
  completeTaskSequence,
  handleFrameAuditSubmitAllAnnotations,
  handleFrameAuditSubmitAcceptedAnnotations,
  handleFrameLabellingSubmitAnnotations,
  handleSaveAllImagesChangedAnnotations,
  deleteTaskImageFromDataset,
  hasReviewTask,
} = useTasks();

const {
  recacheAndSetCurrentSample,
  removeAnnotationsFromCache,
} = useViewerVisualizations();
const visualizationStore = useViewerVisualizationsStore();
const {
  animationImageCache, frame, keyframes, doKeyframesExist,keyFramesEnabled,
} = storeToRefs(visualizationStore);
const {
  removeKeyframe, setKeyframeNew,
} = visualizationStore;

const internalAnnotationDisplaySettings = ref(null);
const submitTypes = ref([
  { title: 'Submit All Annotations', value: 'submit-all-annotations' },
  { title: 'Submit Accepted Annotations', value: 'submit-accepted-annotations' },
]);
const isSubmittingKeyframes = ref(false);

const isKeyframeSelected = computed(() => {
  if (selectedAnnotations.value[0]) {
    const selectedKeyframeObject = keyframes.value.find((keyframeObject) => keyframeObject.id === selectedAnnotations.value[0].id);
    if (selectedKeyframeObject && Object.keys(selectedKeyframeObject.keyframes).map((key) => parseInt(key)).includes(frame.value)) {
      return true;
    }
  }
  return false;
});

const keyframeSelected = computed(() => {
  if (isKeyframeSelected.value) {
    return selectedAnnotations.value[0].id;
  }
  return null;
});

const trackingIdSelected = computed(() => {
  if (selectedAnnotations?.value[0]?.tracking_id) {
    return selectedAnnotations.value[0].tracking_id;
  }
  return null;
});

onMounted(async () => {
  if (annotationDisplaySettings.value) {
    internalAnnotationDisplaySettings.value = annotationDisplaySettings.value;
  }
});

function handleRevertChanges() {
  emit('revert-changes');
}

function handleUndo() {
  emit('undo');
}

function handleShowAnnotationInfo() {
  emit('show-annotation-info');
}

async function handleDeleteImageFromDataset() {
  const resp = await deleteTaskImageFromDataset(currentSample.value?.imageObj?.id)
    .catch((error) => {
      alert(error);
    });
}

function handleSkipSequence() {
  emit('skip');
  skipTaskSequence();
}

async function handleLabellingSubmit() {
  isSubmitting.value = true;
  await handleFrameLabellingSubmitAnnotations(frameImageObj.value);
  currentSample.value.imageObj.annotations = currentSample.value.annotations;
  clearChangedAnnotationsForImage(frameImageObj.value?.id);
  isSubmitting.value = false;

  recacheAndSetCurrentSample();

  emit('submit');
}

function handleReviewSubmit(submitType) {
  if (submitType === 'submit-all-annotations') {
    handleFrameAuditSubmitAllAnnotations(frameImageObj.value)
      .then(() => {
        currentSample.value.imageObj.review_status = "Done";
        clearChangedAnnotationsForImage(frameImageObj.value?.id);
      })
      .catch((err) => {
        console.error(err);
      });
  } else if (submitType === 'submit-accepted-annotations') {
    handleFrameAuditSubmitAcceptedAnnotations(frameImageObj.value)
      .then(() => {
        currentSample.value.imageObj.review_status = "Done";
        clearChangedAnnotationsForImage(frameImageObj.value?.id);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  currentSample.value.imageObj.annotations = currentSample.value.annotations;
  recacheAndSetCurrentSample();
  emit('submit');
}

function handleEnter() {
  emit(submitType.value);
}

// Keyframes
function handleSetKeyframe() {
  selectedAnnotations.value.forEach((anno) => {
    setKeyframeNew(frame.value, currentSample.value.imageObj, anno);
  });
}

function handleRemoveKeyframe() {
  removeKeyframe(keyframeSelected.value);
}

function handleDeleteTrackingIdClicked(trackingId) {
  confirmMessage.value = 'Are you sure you want to permanently delete all annotations from this keyframe series?';
  confirmMessageHeader.value = 'Delete Annotations from Series';
  buttonText.value = 'Delete All';
  confirmModal.value.showModal();
  confirmFunction.value = () => { handleDeleteTrackingId(trackingId); };
}

async function handleSaveNewAnnotations() {
  handleSaveAllImagesChangedAnnotations(changedAnnotations.value);

  newAnnotationsSavePending.value=false;

  window.location.href = window.location.href;

  isSubmitting.value = false;

  emit('submit');
}

async function handleDeleteTrackingId(trackingId) {
  const dataConnect = new DatastoreConnect();
  const removedAnnotations = await dataConnect.deleteAnnotationsByTrackingId({
    tracking_id: trackingId,
    annotation_set_id: reviewSettings.value.reviewTask.dest_annotation_set_id,
  })
    .then((resp) => {
      if (resp.error !== undefined) {
        throw Error(resp.error);
      }
      return resp.result;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });

  if (removedAnnotations.length > 0) {
    removeAnnotationsFromCache(removedAnnotations);
  }
}

// async function handleSubmitKeyframes() {
//   const params = [];
//   keyframeRanges.value.forEach((range) => {
//     const start = keyframes.value[range[0]];
//     const end = keyframes.value[range[1]];
//     start.frame = range[0];
//     end.frame = range[1];
//     params.push([start, end]);
//   });

//   const image_ids = animationImageCache.value.map((item) => item.imageObj.id);
//   const newAnnotations = await submitKeyframes({
//     keyframes: params,
//     image_ids,
//     sequence_id: internalImageObj.value.sequence_id,
//     review_task_id: reviewSettings.value.reviewTask.id,
//     review_session_id: reviewSettings.value.reviewSession.id,
//     annotation_set_id: reviewSettings.value.reviewTask.dest_annotation_set_id,
//   })
//     .catch((error) => {
//       console.error(error);
//     });

//   animationImageCache.value.forEach((cacheFrame) => {
//     if (newAnnotations[cacheFrame.imageObj.id]) {
//       cacheFrame.annotations = newAnnotations[cacheFrame.imageObj.id];
//       cacheFrame.imageObj.annotations = newAnnotations[cacheFrame.imageObj.id];
//     }
//   });

//   keyframes.value = {};
// }

async function handleClearKeyframes() {
  keyframes.value=[];
}

async function handleSubmitKeyframes() {
  //isSubmittingKeyframes.value = true;

  PerformKeyFrameInterpolation(keyframes);





  // const image_ids = Object.values(animationImageCache.value).map((item) => item.imageObj.id);
  // const newAnnotations = await submitKeyframes({
  //   keyframes: keyframes.value,
  //   image_ids,
  //   sequence_id: sequenceId.value,
  //   review_task_id: reviewSettings.value.reviewTask.id,
  //   review_session_id: reviewSettings.value.reviewSession.id,
  //   annotation_set_id: reviewSettings.value.reviewTask.dest_annotation_set_id,
  // })
  //   .catch((error) => {
  //     console.error(error);
  //   });

  // console.log(newAnnotations);

  // Object.values(animationImageCache.value).forEach((cacheFrame) => {
  //   if (newAnnotations[cacheFrame.imageObj.id]) {
  //     newAnnotations[cacheFrame.imageObj.id].forEach((anno) => { anno.reviewStatus = "verified"; });
  //     cacheFrame.annotations = [...cacheFrame.annotations, ...newAnnotations[cacheFrame.imageObj.id]];
  //     cacheFrame.imageObj.annotations = [...cacheFrame.imageObj.annotations, ...newAnnotations[cacheFrame.imageObj.id]];
  //   }
  // });

  // keyframes.value = [];
  isSubmittingKeyframes.value = false;
}

async function submitKeyframes(params) {
  const dataConnect = new DatastoreConnect();
  return dataConnect.submitKeyframes(params)
    .then((resp) => {
      if (resp.error !== undefined) {
        throw Error(resp.error);
      }
      return resp.result;
    })
    .catch((error) => {
      throw error;
    });
}

function handleCopyAnnotation() {
  emit('copy');
}

function handlePasteAnnotation() {
  emit('paste');
}

function handleDeleteAnnotationsBulk() {
  emit('bulk-del-ann');
}

defineExpose({
  handleLabellingSubmit,
});

</script>

<style lang="scss" scoped>
.ribbon {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  min-height: 39px;
  max-height: 39px;
  padding: 2px 16px;
  justify-content: space-between;
  z-index: 10;
  box-shadow: 0 3px 3px -3px gray, 0 10px 10px -10px gray;
  color: var(--ribbon-icons-color);
  background: var(--ribbon-bg);
  border-left: solid 1px var(--ribbon-border);

  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  &__vr {
    display: flex;
    width: 1px;
    height: 60%;
    margin: 0;
  }

  &__button {
    display: flex;
    min-width: 22px;
    height: 22px;
    color: inherit;
    background: none;
    border: none;
    font-size: 0.875rem;
    line-height: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .05em;
    align-items: center;
    cursor: pointer;

    &:hover:not(:disabled), &.active:not(:disabled) {
      box-shadow: 0 0 0 4px var(--icon-hover-color);
      background-color: var(--icon-hover-color);
      border-radius: 4px;
    }

    &:disabled {
      cursor: default;
      color: var(--color-disabled);
    }
  }

  &__button-primary {
    display: flex;
    height: 28px;
    font-size: 0.875rem;
    line-height: 1rem;
    align-items: center;
  }

  &__button-secondary {
    display: flex;
    height: 28px;
    font-size: 0.875rem;
    line-height: 1rem;
    align-items: center;
  }

  &__labeled_button {
    width: auto;
  }
}

:deep(.filter-button) {
  height: 22px;
}

</style>
